import firebaseConfigDev from '../config/firebase/firebase-config-dev'
import firebaseConfigProd from '../config/firebase/firebase-config-prod'
import firebaseConfigStaging from '../config/firebase/firebase-config-staging'
import firebase from 'firebase/app'
import 'firebase/firestore'
import { setFirebaseConfig } from 'daily-dose-common'

let firebaseConfig

if (process.env.ENV === 'production') {
  firebaseConfig = firebaseConfigProd
}

if (process.env.ENV === 'development') {
  firebaseConfig = firebaseConfigDev
}

if (process.env.ENV === 'staging') {
  firebaseConfig = firebaseConfigStaging
}

setFirebaseConfig(firebaseConfig)

// * Set up firebase
export const auth = firebase.auth()
export const firestore = firebase.firestore()
export const storage = firebase.storage()
export const functions = firebase.functions()
